<template>
  <div
    v-if="!myPurchases.length"
  >
   <i>Você ainda não possui cursos avulsos comprados.</i> 
  </div>

  <div
    v-else
    class="row"
  >
    <div
      v-for="purchase in myPurchases"
      :key="purchase.id"
      class="col-md-6 mb-4"
    >
      <CourseThumbBox
       :course="purchase.course" 
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CourseThumbBox from '@/components/course/CourseThumbBox'

  export default {
    components: {
      CourseThumbBox
    },
    computed: {
      ...mapGetters('purchase', ['myPurchases'])
    }
  }
</script>